export default {
    dividers:{
        borderTop: '1px solid #0000006E',
        borderBottom: '1px solid #0000006E'
    }
}